
  import {
    Component,
    Vue,
    Watch
  } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';

  import {
    orderSendImportRecordList
  } from '@/api/order';
  import {
    nextDay
  } from "@/utils"

  let dt = new Date();
  let year = dt.getFullYear();
  let month = dt.getMonth()+1;
  let normalTime = year + '-' + (month>9?month:('0'+month))+'-01';

  @Component({
    name: 'order-result',
    components: {
      PageFooter,
      PickerDate,
    }
  })

  export default class OrderResult extends Vue {
    private keywords = ''
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private list = [];
    private filterTime: any = normalTime + '/';

    private state = null;
    private stateList:any = [{
      label: '全部',
      value: null
    },{
      label: '处理中',
      value: 0
    },{
      label: '已完成',
      value: 1
    }]
   

    private created() {
      this.getList();
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }

    private clearSearch() {
      this.pageNo = 1;
      this.filterTime = normalTime + '/';
      this.state = null;
      this.getList();
    }

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }

    private async getList() {
      let params: any = {
        Keywords:this.keywords,
        Skip:(this.pageNo-1)*this.pageSize,
        Take: this.pageSize,
        ImportState: this.state
      }

      if (this.filterTime) {
        let dt = this.filterTime.split('/');
        params.StartTime = dt[0];
        params.EndTime = dt[1] ? nextDay(dt[1],1) : '';
      }
      try {
        const res: any = await orderSendImportRecordList(params);
        this.list = res.Result.Results;
        this.total = res.Result.Total
      } catch (err) {
        console.log(err);
      }
    }

    /**
     * 下载发货结果
     */
    handleExport(id){
      let url = location.origin + '/provider/order/orderSendDownload?OrderSendImportRecordId='+id;
      window.open(url)
    }

  }
